// Libraries
import { SnackbarProvider } from "notistack";

import PageLayer from "@Layouts/views/PageLayer";
import InventoryLayer from "@DataPages/components/Inventory/InventoryLayer";

// Layouts
import { AUTO_HIDE_DURATION_TEN_SECOND, MAX_SNACK, SnackbarsCustomStyle } from "@/Layouts/components/Snackbars";

// Icons
import inventoryIcon from "@/assets/icons/dataPages/inventory/inventory.svg";
import { ReactComponent as WarningIcon } from "@/assets/icons/svg/yellow_warning.svg";
import { SelectionProvider } from "@/Common/context/selection/SelectionContext";
import { InventoryFilterProvider } from "@/DataPages/components/Inventory/contexts/InventoryFilterContext";

export default function Inventory() {
	return (
		<PageLayer title="Dealer Inventory" icon={inventoryIcon}>
			<SelectionProvider>
				<InventoryFilterProvider>
					<SnackbarProvider
						maxSnack={MAX_SNACK}
						anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
						autoHideDuration={AUTO_HIDE_DURATION_TEN_SECOND}
						iconVariant={{
							warning: <WarningIcon fontSize="small" className="mr-2" />,
						}}
						Components={{
							warning: SnackbarsCustomStyle,
						}}
					>
						<InventoryLayer />
					</SnackbarProvider>
				</InventoryFilterProvider>
			</SelectionProvider>
		</PageLayer>
	);
}
